export default __webpack_public_path__ + "static/bob-belan-1-54410eca86d38436f502dc0ca0571ab3.webp";